import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Sort, SortDirection } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import { ContactInformation } from '../../../classes';

@Component({
  selector: 'app-contact-information-table',
  templateUrl: './contact-information-table.component.html',
  styleUrls: ['./contact-information-table.component.css']
})
export class ContactInformationTableComponent implements OnDestroy, OnInit {

  @Input() disabled: boolean = false;

  columns: string[] = [ 'icon', 'infotype', 'infovalue', 'controls'];

  formGroup: FormGroup;

  active = 'infotype';
  direction: SortDirection = 'asc';

  private _subscriptions: Subscription[] = [];

  constructor(
    private _controlContainer: ControlContainer,
    private _formBuilder: FormBuilder
  ) { }

  addArticle = () => this.itemControl.push(this._formBuilder.group(new ContactInformation()));

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({ contactInformation: this._controlContainer.control as FormArray });
  }

  removeItem(key: number) {
    if (this.itemControl.controls[key]) {
      this.itemControl.removeAt(key);
    }
  }

  sortData(sort: Sort) {
    this.direction = sort.direction;
    this.active = sort.active;
  }

  get itemControl(): FormArray {
    return this.formGroup.controls['contactInformation'] as FormArray;
  }

}
